import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=499898ae"
import script from "./EditOrder.vue?vue&type=script&lang=ts"
export * from "./EditOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports